import React from 'react';
import Text from '../../Text';
import { ExtraTextProps } from './ExtraText.types';

const ExtraText = ({ dataHook, text }: ExtraTextProps) => {
  return (
    <Text secondary dataHook={dataHook}>
      {text}
    </Text>
  );
};

export default ExtraText;
